'use strict';
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _Ellipsis = _interopRequireDefault(require('./lib/icons/Ellipsis'));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _Ellipsis;
  exports.default = _default;
  module.exports = _default;